<template>
    <v-alert
        v-if="sendingBulkMessagesDisabledInProvision"
        color="red lighten-4"
        elevation="2"
        icon="mdi-alert-octagon-outline"
        prominent
    >
        <v-row align="center" no-gutters>
            <v-col class="grow">
                {{ sendingBulkMessagesDisabledInProvisionMessage }}
            </v-col>
            <v-col class="shrink">
                <v-btn icon small @click="refreshStatus" :loading="loading">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-alert>
</template>

<script>
export default {
    name: 'ProvisionWarningBulkMessages',

    data() {
        return {
            sendingBulkMessagesDisabledInProvisionMessage: null,
            loading: false
        }
    },

    mounted() {
        this.refreshStatus();
    },

    methods: {
        refreshStatus() {
            this.loading = true;
            this.$rc.rest({
                endpoint: `GET: /api/v1/provision/bulk-message-disabled-status/${this.$rc.$state.profile?.organization_account?.organization_id}`,
                spinner: false,
                on_success: (data) => {
                    this.sendingBulkMessagesDisabledInProvisionMessage = data.bulk_message_send_disabled_message;
                    this.loading = false;
                },
                on_error: () => {
                    this.loading = false;
                }
            });
        }
    },

    computed: {
        sendingBulkMessagesDisabledInProvision() {
            return this.sendingBulkMessagesDisabledInProvisionMessage != null;
        }
    }
}
</script>

<style lang="scss" scoped>
.nudge-up {
    padding-bottom: 2px;
}
</style>